import moment from "moment";
import {ExchangeMapElementType, ExchangeMapType, ExchangeSearchParamType} from "../interface";

export const exchangeSearchParamInit: ExchangeSearchParamType = {
    endAt: moment().format("YYYY-MM-DD"),
    keywordType: "300",
    keywordType2: "200",
    keywordType2Name: "당일",
    startAt: moment().format("YYYY-MM-DD"),
}

export const exchangeMapElementInit: ExchangeMapElementType = {
    baseExchangeRate: 0,
    cashBuyRate: 0,
    cashSellRate: 0,
    currencyType: "",
    noticeBaseDate: "",
    noticeRound: "",
    regionType: "",
    remittanceReceiveRate: 0,
    remittanceSendRate: 0,
    usdConversionRate: 0,
}

export const exchangeMapInit: ExchangeMapType = {
    searchExchangeResMap: {
        ANZ: {...exchangeMapElementInit, currencyType: "AUD(호주)"},
        CHN: {...exchangeMapElementInit, currencyType: "CNY(중국)"},
        HK: {...exchangeMapElementInit, currencyType: "HKD(홍콩)"},
        IND: {...exchangeMapElementInit, currencyType: "INR(인도)"},
        MY: {...exchangeMapElementInit, currencyType: "MYR(말레이시아)"},
        SEA: {...exchangeMapElementInit, currencyType: "SGD(싱가포르)"},
        USD: {...exchangeMapElementInit, currencyType: "USD(미국)"},
    }
}